import { Navigate, useParams } from 'react-router-dom';

import { useNamespace } from '@splitfiesta/i18n';

import { GroupPageLayout } from '@/components/groups/GroupPageLayout';
import { ActivityFeedContainer } from '@/components/home/ActivityFeed/ActivityFeedContainer';

export default function GroupActivityPage() {
  const { id: groupId } = useParams<{ id: string }>();

  // Load required namespaces - must be before any conditional returns
  const groupsLoaded = useNamespace('groups');
  const activityLoaded = useNamespace('activity');
  const dashboardLoaded = useNamespace('dashboard');

  const allNamespacesLoaded = groupsLoaded && activityLoaded && dashboardLoaded;

  if (!groupId) {
    return <Navigate to="/groups" replace />;
  }

  if (!allNamespacesLoaded) {
    return null; // GroupPageLayout will show skeleton
  }

  return (
    <GroupPageLayout groupId={groupId}>
      <div data-testid="group-activity-container">
        {/* Activity Feed */}
        <ActivityFeedContainer groupId={groupId} showTitle={false} />
      </div>
    </GroupPageLayout>
  );
}
